<template>
  <div class="list-wrap">
    <template v-if="tradeList.length">
      <ul class="trade-list">
        <li class="trade-item" v-for="(item, index) in tradeList" :key="index">
          <div class="trade-item__hd clearfix">
            <span class="trade-item__title">{{ item.remark }}</span>
            <span class="trade-item__money" :class="{'is-navigate': item.direction==0}">
              <span>{{ item.direction==0 ? '-' : '+' }}</span>
              <span>{{ item.transAmount / 100 }}</span>
            </span>
          </div>
          <div class="trade-item__bd">
            <span class="trade-item__date">
              <span>{{ item.createTime }}</span>
            </span>
          </div>
        </li>
      </ul>
      <Pagination
        :total="+pageInfo.total"
        :pageSize="+pageInfo.pageSize"
        :pageIndex="+pageInfo.pageIndex"
        @current-change="onPageIndexChanged"
        ></Pagination>
    </template>
    <p v-else class="no-data">暂无数据</p>
  </div>
</template>

<script>
/* eslint-disable */
import { getTransList } from '@/apis/base';
import { Loadmore, Toast } from 'mint-ui';
import Pagination from '@/components/pagination';

const PAGE_INDEX = 1;
const PAGE_SIZE = 5;

export default {
  props: {
    tradeType: Number
  },
  components: {
    Pagination,
    [Loadmore.name]: Loadmore
  },
  data () {
    return {
      tradeList: [],
      allLoaded: false,
      pageInfo: {
        pageSize: PAGE_SIZE,
        pageIndex: PAGE_INDEX,
        total: 0
      }
    };
  },
  methods: {
    onPageIndexChanged (pageIndex) {
      this.fetchDataList({ pageIndex });
    },
    async fetchDataList ({ pageIndex = PAGE_INDEX, pageSize = PAGE_SIZE }) {
      let result = await getTransList({
        pageIndex: pageIndex,
        pageSize: pageSize,
        type: this.tradeType
      });
      if (result._errCode === '0') {
        this.pageInfo = result._data.pageInfo;
        this.tradeList = result._data.transList;
        if (parseInt(this.pageInfo.pageIndex) >= this.pageInfo.totalPage) {
          this.allLoaded = true;
        }
      } else {
        Toast(result._errStr || '系统错误');
      }
    }
  },
  async mounted () {
    await this.fetchDataList({});
  }
};
</script>

<style lang="postcss" scoped>
.trade-item {
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 16px;
  line-height: 22px;
  border-bottom: 1PX solid #E7ECEE;
  &__title {
    float: left;
  }
  &__money {
    float: right;
    color: #FF8B13;
  }
  &__date {
    color: #999;
  }
  &__bd {
    margin-top: 4px;
  }
  .is-navigate {
    color: #666;
  }
}

.no-data {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
}

.trade-list-wrapper {
  overflow: auto;
  height: 200px;
}

.list-wrap {
  /deep/ .pager-list {
    padding: 20px 0;
    text-align: text;
  }
  /deep/ .pager-item {
    margin: 0;
    a {
      display: inline-block;
      height: 30px;
      padding: 0 6px;
      min-width: 40px;
      margin-right: -1px;
      line-height: 30px;
      color: #666;
      text-align: center;
      border: 1px #eee solid;
      &:hover {
        z-index: 2;
        position: relative;
        color: #3b9bff;
        border-color: #3b9bff;
      }
    }
    &.is-active a {
      z-index: 2;
      position: relative;
      color: #3b9bff;
      border-color: #3b9bff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/wallet/list.vue